import React from 'react';

import TickIcon from "../../assets/images/icons/tick_icon.svg";

/**
 * StepsTracker - JSX component with Tailwind CSS
 * Visual progress indicator for multi-step forms
 * 
 * Features:
 * - Three-step progress visualization
 * - Active step highlighting
 * - Completed step checkmarks
 * - Responsive mobile layout
 * 
 * @param {number} currentStep - Current active step (1-3)
 */

const StepsTracker = ({ currentStep = 1 }) => {
  const steps = [
    { number: 1, text: 'Personal details' },
    { number: 2, text: 'Location details' },
  ];

  const getStepStatus = (stepNumber) => {
    if (stepNumber < currentStep) return 'completed';
    if (stepNumber === currentStep) return 'active';
    return 'inactive';
  };

  return (
    <div className="flex gap-6 mb-5 items-center justify-center flex-col md:flex-row md:text-left text-center">
      {steps.map((step) => {
        const status = getStepStatus(step.number);
        return (
          <div 
            key={step.number}
            className={`flex items-center gap-2 text-sm ${
              status === 'active' || status === 'completed' ? 'text-[#FEFCEB]' : 'text-[#7F8585]'
            }`}
          >
            <span
              className={`w-6 h-6 rounded-full flex items-center justify-center text-sm font-medium ${
                status === 'active' || status === 'completed'
                  ? 'bg-[#00E7FF] text-[#000F1F]'
                  : 'bg-[#192634] text-[#7F8585]'
              }`}
            >
              {status === 'completed' ? (
                <img src={TickIcon} alt="Completed" className="w-3 h-3" />
              ) : (
                step.number
              )}
            </span>
            <span className="text-sm font-medium">{step.text}</span>
          </div>
        );
      })}
    </div>
  );
};

export default StepsTracker;